import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditGoldCatalogue = () => {
    const { id } = useParams();  // Get the catalogue id from the URL
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const [subCategoryId, setSubCategoryId] = useState('');
    const [image, setImage] = useState(null);
    const [weight, setWeight] = useState('');
    const navigate = useNavigate();

    // Fetch categories and subcategories when the component mounts
    useEffect(() => {
        // Fetch categories
        fetch(`${BASE_URL}categories`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setCategories(data.data); // Store categories
                } else {
                    alert('Error fetching categories');
                }
            })
            .catch(error => console.error('Error fetching categories:', error));

        // Fetch subcategories
        fetch(`${BASE_URL}subcategories`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setSubCategories(data.data); // Store subcategories
                } else {
                    alert('Error fetching subcategories');
                }
            })
            .catch(error => console.error('Error fetching subcategories:', error));

        // Fetch the gold catalogue data for the provided id
        fetch(`${BASE_URL}goldCatalogue/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const catalogue = data.data;
                    setCategoryId(catalogue.category_id); // Set current category
                    setSubCategoryId(catalogue.sub_category_id); // Set current subcategory
                    setImage(catalogue.image); // Set current image (optional)
                    setWeight(catalogue.weight); // Set current weight
                } else {
                    alert('Error fetching catalogue details');
                }
            })
            .catch(error => console.error('Error fetching catalogue details:', error));
    }, [id]);

    // Handle form input changes
    const handleCategoryChange = (event) => {
        setCategoryId(event.target.value);
    };

    const handleSubCategoryChange = (event) => {
        setSubCategoryId(event.target.value);
    };

    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };

    const handleImageChange = (event) => {
        setImage(event.target.files[0]);
    };

    // Handle form submission to update the gold catalogue
    const handleSubmit = (event) => {
        event.preventDefault();

        // Create form data to send the image and other details
        const formData = new FormData();
        formData.append('category_id', 1);
        formData.append('sub_category_id', subCategoryId);
        formData.append('weight', weight);
        if (image) {
            formData.append('image', image);
        }

        // PUT request to update the gold catalogue
        fetch(`${BASE_URL}goldCatalogue/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Catalogue updated successfully');
                    navigate('/GoldCatalogueList'); // Navigate to Gold Catalogue list after success
                } else {
                    alert('Error updating catalogue');
                }
            })
            .catch(error => {
                console.error('Error updating gold catalogue:', error);
                alert('Error updating catalogue');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Gold Catalogue</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Gold Catalogue Form */}
            <section className="section">
                <div className="row" id="form-row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Gold Catalogue</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* <div className="mb-3">
                                        <label htmlFor="category" className="form-label">Category</label>
                                        <select
                                            id="category"
                                            className="form-select"
                                            value={categoryId}
                                            onChange={handleCategoryChange}
                                            required
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map(category => (
                                                <option key={category.id} value={category.id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div> */}

                                    <div className="mb-3">
                                        <label htmlFor="subCategory" className="form-label">Sub Category</label>
                                        <select
                                            id="subCategory"
                                            className="form-select"
                                            value={subCategoryId}
                                            onChange={handleSubCategoryChange}
                                            required
                                        >
                                            <option value="">Select Subcategory</option>
                                            {subCategories.map(subCategory => (
                                                <option key={subCategory.id} value={subCategory.id}>
                                                    {subCategory.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="weight" className="form-label">Weight</label>
                                        <input
                                            type="number"
                                            id="weight"
                                            className="form-control"
                                            value={weight}
                                            onChange={handleWeightChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={handleImageChange}
                                        />
                                        {image && (
                                            <div className="mt-2">
                                                <strong>Current Image:</strong>
                                                <img
                                                    src={`${BASE_URL}${image}`}
                                                    alt="Current catalogue"
                                                    width="100"
                                                    height="100"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <button type="submit" className="btn btn-primary">Update Catalogue</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditGoldCatalogue;
